// DS v2 §3 type roles: titles and KPI values in Poppins, everything else Inter.
export const PAGE_TITLE =
  'font-display text-fs-22 tracking-heading text-fg-1 font-semibold';

export const SECTION_TITLE = 'font-display text-fs-16 text-fg-1 font-semibold';

// A heading nested inside a titled card, and the DS §6.5 recommendation title.
export const SUBHEADING = 'text-fs-14 text-fg-1 font-semibold';

export const KPI_VALUE =
  'font-display text-fs-24 text-fg-1 leading-none font-bold';

export const LABEL = 'text-fs-12 text-fg-4 font-medium';

export const OVERLINE =
  'text-fs-11 tracking-caps text-fg-4 font-semibold uppercase';

// Flow spec §5: the right-panel headline of the auth and onboarding screens.
export const AUTH_HEADLINE =
  'font-display text-fs-32 tracking-headline text-fg-1 font-semibold';

// Flow spec §6.1 and §12: the stage claim, 46px on the split, 32px stacked.
export const STAGE_HEADLINE =
  'font-display text-fs-32 split:text-fs-46 tracking-heading text-fg-1 font-semibold';
